import React, { Component } from 'react'
import { iAxios } from '../../lib/utils';
import Icon from '../ds/Icon';

const $ = window.$;

String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

const statusList = [
    "ACCEPT",
    "REJECT",
    "NOT_RECHABLE",
    "PEDNING",
    "SHORTLIST"
];

const DetailModal = ({ resume, handleHide }) => (
    <div className="ds-scope ds-modal is-open" onMouseDown={(e) => { if (e.target === e.currentTarget) handleHide(); }}>
        <div className="ds-modal__dialog ds-modal--wide" role="dialog" aria-modal="true" aria-label="Resume detail">
            <button type="button" className="ds-btn is-ghost is-icon ds-modal__close" aria-label="Close" onClick={() => handleHide()}>
                <Icon name="close" />
            </button>
            <div dangerouslySetInnerHTML={{
                __html: resume.resume && resume.resume.replaceAll('style=.*display.*none', '')
            }} />
        </div>
    </div>
);

class ResumeBlock extends Component {
    constructor(props) {
        super(props);
        this.state = { resume: props.resume };
    }

    updateStatus(evt) {
        evt.preventDefault();
        iAxios.post('/api/v1/utils/scrap-update', {
            id: this.state.resume.id,
            status: this.refs.option_ref.value
        }).then(resp => {
            this.setState({ resume: resp.data });
        });
    }

    render() {
        const { resume } = this.state;
        const { showModal } = this.props;
        return (
            <div className="resume-card">
                <button type="button" className="ds-btn is-soft is-sm" style={{ float: 'right' }} onClick={() => showModal(resume)}>Open</button>
                <div dangerouslySetInnerHTML={{
                    __html: resume.summary && resume.summary.replaceAll('style=.*display.*none', '')
                }} />
                <form onSubmit={this.updateStatus.bind(this)} className="resume-card__foot">
                    <span className="ds-badge is-warning">{resume.status}</span>
                    <select ref="option_ref" className="ds-select" style={{ maxWidth: '200px' }} aria-label="Set status">
                        {statusList.map(i => <option key={i} value={i}>{i}</option>)}
                    </select>
                    <button type="submit" className="ds-btn is-primary is-sm">Submit</button>
                </form>
            </div>
        );
    }
}

class ResumeSearch extends Component {
    constructor(arg) {
        super(arg);
        this.state = {
            resumeList: [],
            total: 0,
            modal: null
        };
        this.showModal = this.showModal.bind(this);
    }

    showModal(item) {
        if (!item) {
            return this.setState({ modal: null });
        }
        this.setState({
            modal: <DetailModal resume={item} handleHide={this.showModal} />
        });
    }

    searchRes(e) {
        e.preventDefault();
        this.setState({ resumeList: [] });
        iAxios.get('/api/v1/utils/scrap', {
            params: {
                r: $("#resume_text").val(),
                s: $("#summary_text").val(),
                f: $("#filter").val(),
            }
        }).then(res => {
            this.setState({
                total: res.data.total,
                resumeList: res.data.result
            });
        });
    }

    render() {
        const { resumeList } = this.state;
        const list = resumeList.map(item => (
            <ResumeBlock key={item.id} resume={item} showModal={this.showModal} />
        ));
        return (
            <div>
                <div className="page-head"><h2>Resume Search</h2></div>

                <form className="ds-field-row" onSubmit={this.searchRes.bind(this)}>
                    <input type="text" placeholder="Resume" id="resume_text" className="ds-input ds-field" />
                    <input type="text" placeholder="Summary" id="summary_text" className="ds-input ds-field" />
                    <select id="filter" className="ds-select" style={{ maxWidth: '160px' }} aria-label="Filter">
                        <option value="ACTIVE">Active</option>
                        <option value="ALL">All</option>
                        {statusList.map(i => <option key={i} value={i}>{i}</option>)}
                    </select>
                    <button type="submit" className="ds-btn is-primary">Search</button>
                </form>

                <div style={{ margin: 'var(--ds-space-2) 0 var(--ds-space-4)', color: 'var(--ds-ink-muted)' }}>
                    Total: <b className="ds-nums">{this.state.total}</b>
                </div>
                <div>{list}</div>
                {this.state.modal}
            </div>
        );
    }
}

export default ResumeSearch;
